export default {
  'User name': 'Username',
  nickname: 'Nickname',
  grouping: 'Group',
  'head portrait': 'Profile picture',
  Gender: 'Gender',
  male: 'Male',
  female: 'Female',
  mobile: 'Mobile Number',
  'Last login IP': 'Last login IP',
  'Last login': 'Last login',
  email: 'Email',
  birthday: 'Birthday',
  balance: 'Balance',
  'Adjustment balance': 'Adjust balance',
  integral: 'Integral',
  'Adjust integral': 'Adjust integral',
  password: 'Password',
  'Please leave blank if not modified':
    'Please leave blank if you do not modify',
  'Personal signature': 'Personal signature',
  'Login account': 'Login account name'
}
